import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Modal, Input } from '../../components/index';
import Masks from '../../utils/masks';
import {
  doPut,
  trataMensagemSucesso,
} from '../../utils/requests';

class ModalAlteracaoDataCessacao extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    dataCessacaoBeneficio: this.props.dataCessacaoBeneficio,
    motivoCessacaoManual: this.props.estadoFormulario.requerimento.motivoCessacaoManual,
    touched: false,
  });

  checkIfFileCanBeSent = () => (this.state.dataCessacaoBeneficio || this.state.dataCessacaoBeneficio === '');

  diffRequerimento = () => {
    const { tipoRequerimento } = { ...this.props };
    if (tipoRequerimento === 2) {
      return 'pensao';
    }
    return 'aposentadoria';
  }

  handleSave = () => {
    const tipo = this.diffRequerimento();
    const url = `alterar-data-cessacao-requerimento-${tipo}`;
    const { protocolo } = { ...this.props };
    const { motivoCessacaoManual, dataCessacaoBeneficio } = { ...this.state };
    const objProtocolo = protocolo;
    let objMotivoCessacaoManual = motivoCessacaoManual;
    if (objMotivoCessacaoManual === '') {
      objMotivoCessacaoManual = null;
    }
    const objAlteracao = { protocolo: objProtocolo, motivoCessacaoManual: objMotivoCessacaoManual, dataCessacao: dataCessacaoBeneficio };
    let options;
    if (this.state.chaveConfirmacao) {
      options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
    }
    doPut(
      url,
      objAlteracao,
      this.trataSucessoResponseEnvio,
      this.trataErrosResponse,
      options,
    );
  }

  trataSucessoResponseEnvio = () => {
    const { tipoRequerimento } = { ...this.props };
    this.handleClose();
    this.props.atualizarDataCessacao(this.state.dataCessacaoBeneficio);
    if (tipoRequerimento === 1) {
      this.props.atualizarMotivoCessacao(this.props.estadoFormulario.requerimento.motivoCessacaoManual);
    }
    trataMensagemSucesso(['Data de cessação do benefício alterada']);
  }

  modalContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="8 8 12 12">
          <Input
            label="Data de Cessação"
            mask={Masks.date}
            value={this.state.dataCessacaoBeneficio}
            onChange={e => this.handleChange(e, 'dataCessacaoBeneficio')}
            touched={this.state.touched}
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  modalFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          disabled={!this.checkIfFileCanBeSent()}
          hint="Salvar"
          onClick={this.handleSave}
          title="Salvar"
        />
      </div>
    </React.Fragment>
  )

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleClose = () => {
    this.setState({ dataCessacaoBeneficio: null }, this.props.handleModal('exibirModalDataCessacao'));
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="md"
        showModal={this.props.showModal}
        title="Alterar a data de cessação do requerimento"
      />
    );
  }
}

ModalAlteracaoDataCessacao.propTypes = {
  tipoRequerimento: PropTypes.number.isRequired,
  protocolo: PropTypes.string.isRequired,
  dataCessacaoBeneficio: PropTypes.string.isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  atualizarDataCessacao: PropTypes.func,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  atualizarMotivoCessacao: PropTypes.func,
}.isRequired;

export default ModalAlteracaoDataCessacao;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalAlteracaoDataCessacao.jsx